// extracted by mini-css-extract-plugin
export var active = "StickyAnchorNav-module--active--ac0bb";
export var activeLink = "StickyAnchorNav-module--activeLink--b1ea8";
export var nav = "StickyAnchorNav-module--nav--3e812";
export var navLink = "StickyAnchorNav-module--navLink--a43ec";
export var navList = "StickyAnchorNav-module--navList--ea445";
export var paragraph = "StickyAnchorNav-module--paragraph--d6763";
export var paragraphSm = "StickyAnchorNav-module--paragraph-sm--058d0";
export var paragraphXs = "StickyAnchorNav-module--paragraph-xs--c58f2";
export var titleH1 = "StickyAnchorNav-module--title-h1--fc2f8";
export var titleH1Alt = "StickyAnchorNav-module--title-h1--alt--2fb6c";
export var titleH2 = "StickyAnchorNav-module--title-h2--3fbb6";
export var titleH2Alt = "StickyAnchorNav-module--title-h2--alt--b92e4";
export var titleH3 = "StickyAnchorNav-module--title-h3--c50f4";
export var titleH3Alt = "StickyAnchorNav-module--title-h3--alt--95316";
export var titleH4 = "StickyAnchorNav-module--title-h4--40f8d";
export var titleH4Alt = "StickyAnchorNav-module--title-h4--alt--9bf59";
export var titleH5 = "StickyAnchorNav-module--title-h5--9a6e6";